import { render, staticRenderFns } from "./addActive.vue?vue&type=template&id=5fea6e0c&"
import script from "./addActive.vue?vue&type=script&lang=js&"
export * from "./addActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports